import { render, staticRenderFns } from "./forex-menu.vue?vue&type=template&id=1b7d5612&scoped=true"
import script from "./forex-menu.vue?vue&type=script&lang=js"
export * from "./forex-menu.vue?vue&type=script&lang=js"
import style0 from "./forex-menu.vue?vue&type=style&index=0&id=1b7d5612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d5612",
  null
  
)

export default component.exports